import React, { Component } from "react";
import __ from "lodash";
import { cekCookies } from "../../../../actions";
import history from "../../../../history";
import { connect } from "react-redux";
import { CONFIG, URL_AKM } from "../../../../config";
import accountManagement from "../../../../apis/accountManagement";
import akmApi from "../../../../apis/akmApi";
import { Form, Alert } from "react-bootstrap";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import LoaderModal from "../../../modal/LoaderModal";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import DropdownMapel from "../masterDropDown/DropdownMapel";
import { Switch, TextField } from "@material-ui/core";
import SubProfilCbt from "../../../../entity/SubProfilCbt";
import { Autocomplete } from "@material-ui/lab";

class FormSubProfil extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      profil: {},
      subProfil: SubProfilCbt,
      mapel: [],
      kategori: [],
      action: "add",
      alertShow: false,
      resMessage: "",
    };
  }

  async componentDidMount() {
    const { profil, subProfil } = this.props.location.state;
    this.setState({ isFetching: true, profil: profil });
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      console.log(subProfil);
      this.fetchMapel();
      this.fetchKategori();
    }
    if (!__.isEmpty(subProfil)) {
      this.setState({
        subProfil: subProfil,
        action: "edit",
      });
    }
    this.setState({ isFetching: false });
  }

  fetchMapel = async () => {
    const response = await akmApi.get(URL_AKM.MAPEL_GET_BY_IDKELASGROUP + this.state.profil.idKelasGroup).catch(function (error) {
      alert(error);
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          mapel: response.data.data,
        });
      }
    }
  };

  dropMapel() {
    return <DropdownMapel mapel={this.state.mapel} />;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { subProfil, profil } = this.state;
    // if(subProfil.idMataPelajaran === null && subProfil.idTematik == null) {
    //     this.setState({ alertShow: true, resMessage: 'Mata Pelajaran atau Tematik harus dipilih...'})
    //     return false;
    // }

    this.setState({ isFetching: true });
    subProfil.idProfilCbt = profil.idProfilCbt;
    let apiSubUrl;
    if (subProfil.idSubProfilCbt === null) {
      apiSubUrl = CONFIG.EXAM_ADD_MAPEL;
    } else {
      apiSubUrl = CONFIG.EXAM_EDIT_MAPEL;
    }

    const res = await akmApi.post(URL_AKM.POST_ADD_SUBPROFIL, subProfil).catch(function (error) {
      this.setState({ alertShow: true, resMessage: error });
    });
    if (res) {
      if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.handleBack();
      } else {
        this.setState({
          isFetching: false,
          alertShow: true,
          resMessage: res.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchKategori = async () => {
    const response = await akmApi.get(URL_AKM.GET_KATEGORI_SUB_PROFIL).catch(function (error) {
      alert(error);
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          kategori: response.data.data,
        });
      }
    }
  };

  handleAutoComplete = async (event, value, reason) => {
    const id = event.target.id;
    const idSplit = id.split("-");
    // console.groupCollapsed("====== HANDLE AUTO COMPLETE ======");
    // console.info("idSplit", idSplit);
    // console.info("event", event.target.id);
    // console.info("value", value);
    // console.info("reason", reason);
    // console.groupEnd();
    this.setState({ subProfil: { ...this.state.subProfil, [idSplit[0]]: value.idMataPelajaran } });
  };

  render() {
    const { subProfil, action, mapel } = this.state;
    let pageTitle;
    if (action === "edit") {
      pageTitle = "Edit Mapel Test";
    } else {
      pageTitle = "Add Mapel Test";
    }

    return (
      <div className="wrapper">
        <LoaderModal isFetching={this.state.isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar title={pageTitle} />
          {this.loadAlert()}

          <Form onSubmit={this.handleSubmit}>
            <div className="row mb-3">
              <div className="col-sm-6 col-xs-6">
                <Form.Group controlId="idMapel">
                  <Form.Label>Mata Pelajaran :</Form.Label>
                  {/* <select className="form-control" name="idMataPelajaran" value={subProfil.idMataPelajaran} onChange={this.handleChangeMapel}>
                    <option value="">None...</option>
                    {this.dropMapel()}
                  </select> */}
                  <Autocomplete
                    id="idMataPelajaran"
                    size="small"
                    onChange={this.handleAutoComplete}
                    disableClearable={true}
                    options={mapel}
                    value={subProfil.idMataPelajaran ? mapel.find((x) => x.idMataPelajaran == subProfil.idMataPelajaran) : ""}
                    getOptionLabel={(mapel) => mapel.namaMataPelajaran}
                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                  />
                </Form.Group>
              </div>

              <div className="col-sm-6 col-xs-6">
                <Form.Group controlId="tematik">
                  <Form.Label>Tematik :</Form.Label>
                  <select className="form-control" name="idTematik" value={subProfil.idTematik} onChange={this.handleChangeTema}>
                    <option value="">None...</option>
                  </select>
                </Form.Group>
              </div>
            </div>
            {/* <div className="row mb-3">
                            <div className="col-sm-4 col-xs-4"> 
                                <Form.Group controlId="pointBenar">
                                    <Form.Label>Point Benar :</Form.Label>
                                    <Form.Control
                                        type="number" maxLength={100}
                                        name="pointBenar" 
                                        value={subProfil.pointBenar === null  ? '1' : subProfil.pointBenar}
                                        onChange={this.handleChangeBenar}                                   
                                        placeholder="Point Benar..." required/>
                                </Form.Group>
                            </div>
                            <div className="col-sm-4 col-xs-4"> 
                                <Form.Group controlId="pointSalah">
                                    <Form.Label>Point Salah :</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="pointSalah" 
                                        value={subProfil.pointSalah === null  ? '0' : subProfil.pointSalah}
                                        onChange={this.handleChangeSalah}                                  
                                        placeholder="Point Salah..." required/>
                                </Form.Group>
                            </div>
                            <div className="col-sm-4 col-xs-4"> 
                                <Form.Group controlId="pointTakTerJawab">
                                    <Form.Label>Point Tidak Jawab :</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="pointTakTerjawab" 
                                        value={subProfil.pointTakTerjawab === null  ? '0' : subProfil.pointTakTerjawab}
                                        onChange={this.handleChangeTakJawab}                                  
                                        placeholder="Point Tidak Jawab..." required/>
                                </Form.Group>
                            </div>                  
                        </div> */}
            <div className="row mb-3">
              <div className="col-sm-4 col-xs-4">
                <Form.Group controlId="durasi">
                  <Form.Label>Durasi :</Form.Label>
                  <Form.Control type="number" name="durasi" value={subProfil.durasi === null ? "60" : subProfil.durasi} onChange={this.handleChangeDurasi} placeholder="Durasi..." required />
                </Form.Group>
              </div>
              <div className="col-sm-4 col-xs-4">
                <Form.Group controlId="kkm">
                  <Form.Label>Ketuntasan Minimum :</Form.Label>
                  <Form.Control
                    type="number"
                    name="ketuntasanMinimum"
                    value={subProfil.ketuntasanMinimum === null ? "65" : subProfil.ketuntasanMinimum}
                    onChange={this.handleChangeKkm}
                    placeholder="Ketuntasan Minimum..."
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-sm-4 col-xs-4">
                <Form.Group controlId="essay">
                  <Form.Label>Prosentase Essay :</Form.Label>
                  <Form.Control
                    type="number"
                    name="prosentaseEssay"
                    value={subProfil.prosentaseEssay === null ? "0" : subProfil.prosentaseEssay}
                    onChange={this.handleChangeEssay}
                    placeholder="Ketuntasan Minimum..."
                    required
                  />
                </Form.Group>
              </div>
            </div>
            <div></div>
            <div className="row mb-3">
              {this.state.profil.kodeSubTipeCbt === "AN" ||
                (this.state.profil.kodeSubTipeCbt === "SBMPTN" && (
                  <div className="col-sm-4 col-xs-4">
                    <Form.Label>Kategori :</Form.Label>
                    <Form.Group>
                      <select className="form-control" required={true} name="kategori" value={subProfil.idKategoriSubProfil} onChange={this.handleChangeKategori}>
                        <option value="">Pilih Kategori Sub...</option>
                        {this.state.kategori.map((value, idx) => (
                          <option value={value.idKategoriSubProfil} key={idx}>
                            {value.namaKategoriSubProfil}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>
                ))}

              <div className="col-sm-4 col-xs-4">
                <Form.Label>Random :</Form.Label>
                <Form.Group>
                  <small>off</small>{" "}
                  <Switch color="primary" value={subProfil.random === null ? "0" : subProfil.random} onChange={(e) => this.handleChangeRandom(e)} checked={subProfil.random === 1 ? true : false} />{" "}
                  <small>on</small>
                </Form.Group>
              </div>
            </div>
            <div>
              <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}>
                <ArrowBackIosIcon fontSize="small" />
                Batal
              </button>

              <button type="submit" className="btn btn-primary pull-right">
                Simpan
              </button>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  handleBack() {
    if (this.state.profil.kodeSubTipeCbt === "TRYOUT") history.push({ pathname: "/mgttoo", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "AGCU") history.push({ pathname: "/mgtagcu", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "PEMINATAN") history.push({ pathname: "/mgtpeminatan", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "PEMETAAN") history.push({ pathname: "/mgtpemetaan", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "PEMETAAN2") history.push({ pathname: "/mgtpemetaan2", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "PEMETAAN3") history.push({ pathname: "/mgtpemetaan3", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "ENSA") history.push({ pathname: "/mgtensa", state: { kodeSubTipeCbt: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "AN") history.push({ pathname: "/akm", state: { profil: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "QUEST") history.push({ pathname: "/profil_qs", state: { profil: this.state.profil } });
    if (this.state.profil.kodeSubTipeCbt === "SBMPTN") history.push({ pathname: "/mgtsbmptn", state: { profil: this.state.profil } });
  }

  handleChangeMapel = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, idMataPelajaran: event.target.value } });
  };
  handleChangeTema = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, idTematik: event.target.value } });
  };
  handleChangeBenar = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, pointBenar: event.target.value } });
  };
  handleChangeSalah = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, pointSalah: event.target.value } });
  };
  handleChangeTakJawab = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, pointTakTerJawab: event.target.value } });
  };
  handleChangeKkm = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, ketuntasanMinimum: event.target.value } });
  };
  handleChangeDurasi = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, durasi: event.target.value } });
  };
  handleChangeRandom = (event) => {
    let isChecked = event.target.checked;
    if (isChecked) {
      this.setState({ subProfil: { ...this.state.subProfil, random: 1 } });
    } else {
      this.setState({ subProfil: { ...this.state.subProfil, random: 0 } });
    }
  };
  handleChangeEssay = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, prosentaseEssay: event.target.value } });
  };
  handleChangeKategori = (event) => {
    this.setState({ subProfil: { ...this.state.subProfil, idKategoriSubProfil: event.target.value } });
  };

  loadAlert = () => {
    const { alertShow } = this.state;
    if (alertShow) {
      return (
        <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{this.state.resMessage}</strong>
        </Alert>
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(FormSubProfil);
